import { Button, Modal, Dialog, Divider } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import ProceduresManualContext from "./ProceduresManualContext";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import moment from 'moment';


const TitleContainer = styled.div`
width:100%;
color: white;
font-family: Roboto;
font-size: 20px;
font-weight: 500;
letter-spacing: 0.25px;
line-height: 24px;
text-align: left;
padding:20px;
height:80px;
background-color:RGB(48, 74, 87);
display:flex;
align-items:center;
`

const ContentContainer = styled.div`
  padding-left:20px;
  padding-right:20px;
  overflow-y:auto;
  padding-top:10px;
  min-height:250px;

`

const ButtonsContainer = styled.div`
display:flex;
width:100%;
align-items:center;
justify-content:flex-end;
height:80px;
padding-right:20px;
`

const ButtonContainer = styled.div`
width:90px;
margin-left:20px;
`


const Header = styled.div`
    color: rgba(0, 0, 0, 0.50);
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    padding-bottom:10px;
    padding-top:10px;
`;

const OneTimeHeader = styled.div`
    color: rgba(0, 0, 0, 0.50);
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    padding-top:10px;
`;

const Container = styled.div`

width:760px;
display:flex;
flex-direction:column;
align-items:space-between;
 
`;


const FileButtonContainer = styled.div`
    padding-bottom:20px;
    display:flex;
    align-items:center;
`

const Section = styled.div`
  padding-top:10px;
  padding-bottom:10px;

`;

const SectionTitle = styled.div`
font-family: Roboto;
font-size: 15px;
font-weight: 500;
padding-bottom:10px;
`;

const Body = styled.div`
font-family: Roboto;
font-size: 15px;
font-weight: 400;
`;



class ActionDeviationDialogReadOnlyV2 extends React.Component {

  static contextType = ProceduresManualContext;

  renderAttachments(attachments) {

    if (attachments && attachments.length) {
      return (
        <Section>
          <SectionTitle>
            Attachments:
          </SectionTitle>
          {this.context.deviationAction.attachments.map(attachment =>
            <FileButtonContainer>
              <AttachFileIcon />
              <a href={`/api/attachments/download/${attachment.id}`}>{attachment.virtualPath}</a>
            </FileButtonContainer>

          )}
        </Section>
      )
    } else {
      return null
    }




  }

  renderOneTimeDeviation(deviation) {
    if (!deviation) return null;

    const { sdn, title, url, status, deviationReasoning, requestDate } = deviation;
    const formattedDate = moment(requestDate).format("D MMM YYYY");
    return (
      <div>
        <Divider />
        <OneTimeHeader>
          {`One-Time Deviation - ${formattedDate}`}
        </OneTimeHeader>
        <Section>
          <SectionTitle>
            Reason:
          </SectionTitle>
          <Body>
            {deviationReasoning}
          </Body>
        </Section>

        {sdn &&
          <Section>
            <SectionTitle>
              Modification or Addendum:
            </SectionTitle>
            <Body>
              <a target="_blank" href={`${url}`}>{`${sdn}-${title}`}</a>
            </Body>
          </Section>
        }
      </div>
    )

  }



  render() {

    const deviationAction = this.context.deviationAction;

    if (!deviationAction) {
      return null;
    }

    const { sdn, title, attachments, modifiedProcedureSdn, modifiedProcedureTitle, modifiedProcedureUrl, deviationReasoning, isDeviating, deviationComments, procedureSdn, procedureName } = deviationAction;

    let isDeviatingText = "";


    if (!deviationComments && deviationReasoning) {
      isDeviatingText = `Deviating from procedure ${sdn}  -  ${title}`;
    } else if (deviationComments) {
      isDeviatingText = `Project will use the prior version of ${sdn}  -  ${title}`;
    }


    return (

      <Dialog maxWidth='xl' open={this.context.deviationAction}>
        <Container >



          <TitleContainer><div>Reason for Non-Compliance</div></TitleContainer>

          <ContentContainer style={{ maxHeight: window.innerHeight - 300 }}>
            {isDeviatingText &&
              <Section>
                <Body>
                  {isDeviatingText}
                </Body>
              </Section>
            }
            {(deviationReasoning || deviationComments) &&
              <Section>
                <SectionTitle>
                  Reason:
                </SectionTitle>
                <Body>
                  {deviationReasoning ? deviationReasoning : deviationComments}
                </Body>
              </Section>
            }
            {modifiedProcedureSdn &&
              <Section>
                <SectionTitle>
                  Modification or Addendum:
                </SectionTitle>
                <Body>
                  <a target="_blank" href={`${modifiedProcedureUrl}`}>{`${modifiedProcedureSdn}-${modifiedProcedureTitle}`}</a>
                </Body>
              </Section>
            }
            {this.renderAttachments(attachments)}
          </ContentContainer>
          <div>
            <Divider />
            <ButtonsContainer>
              <Button
                variant="outlined"
                onClick={() => {

                  this.context.displayDeviationReasoning(null);
                }}
              >Close</Button>
            </ButtonsContainer>
          </div>


        </Container>
      </Dialog>
    );
  }
}

export default ActionDeviationDialogReadOnlyV2;
